import React, { useState, useEffect, useRef } from "react";
import WebViewer from "@pdftron/webviewer";
import httpClient from "../../lib/HttpClient";
import axiosClient from "../../lib/axios-client";
import download from "downloadjs";
import security from "../../services/Security";

import {
  apiUrl,
  pdftronServerUrl,
  loadDocumentUrl,
} from "../../lib/axios-client";

import DownloadSVG from "../../images/icons/svg/share-link-download-mobile.svg";
import styles from "./GuestViewer.module.scss";
import stampTool from "../../pdf/tools/Stamp";

const PDFTGuestViewer = (props) => {
  const viewerRef = useRef(null);
  const hashUrl = props.hashUrl;

  const addCommentStampImage = (xfdfHighlightString) => {
    let stampImageTag;
    const regexOne = /<imagedata><\/imagedata>/;
    const regexTwo = /<imagedata\/>/;

    if (xfdfHighlightString.match(regexOne)) {
      stampImageTag = /<imagedata><\/imagedata>/;
    } else if (xfdfHighlightString.match(regexTwo)) {
      stampImageTag = /<imagedata\/>/;
    }

    const xfdfWithStampImages = xfdfHighlightString.replace(
      stampImageTag,
      "<imagedata>data:image/svg+xml;base64,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</imagedata>"
    );

    return xfdfWithStampImages;
  };

  const isImportedAnnotation = (annot) => {
    if (typeof annot.isInternal() !== "undefined") {
      return true;
    }
  };

  const addStampImageToPinComments = (conversations) => {
    const conversationsWithStamps = conversations.map((conversation) => {
      if (conversation.xfdf_highlight_string) {
        conversation.xfdf_highlight_string = addCommentStampImage(
          conversation.xfdf_highlight_string
        );
        return conversation;
      } else {
        return conversation;
      }
    });

    return conversationsWithStamps;
  };

  let documentContainer = null;

  const downloadDoc = (documentDetails) => {
    const url = `/share_links/download`;
    const title = `${documentDetails.title}${documentDetails.file_extension}`;
    const type = documentDetails.mime_type;
    const token = security.getToken();

    axiosClient({
      method: "post",
      url: url,
      responseType: "arraybuffer",
      headers: { Authorization: `Bearer ${token}` },
      data: {
        hash_url: hashUrl,
        session_id: props.sessionId,
      },
    }).then(function (response) {
      if (documentDetails.generated) {
        let instance = window.WebViewer.getInstance();
        instance.UI.downloadPdf({
          filename: `${documentDetails.title}.pdf`,
        });
      } else {
        download(response.data, title, type);
      }
    });
  };

  useEffect(() => {
    httpClient
      .get(`${loadDocumentUrl()}/share_links/view/${hashUrl}`)
      .then((res) => {
        const loadDocument = async () => {
          try {
            let webViewerOptions = {
              path: "/vendor/pdf/lib",
              fullAPI: false,
              disabledElements: [
                "undoButton",
                "eraserToolButton",
                "redoButton",
                "rubberStampToolGroupButton",
                "signatureToolGroupButton",
                "calloutToolGroupButton",
                "annotationPopup",
                "notesPanelResizeBar",
                "filterAnnotationButton",
                "notesOrderDropdown",
                "thumbDelete",
                "thumbRotateClockwise",
                "leftPanelResizeBar",
                "searchPanelResizeBar",
                "fullscreenButton",
                "printButton",
                "themeChangeButton",
                "deletePage",
                "insertPageBelow",
                "insertPageAbove",
                "pageInsertionHeader",
                "selectToolButton",
                "toggleNotesButton",
                "menuButton",
                "annotationCommentButton",
                "annotationStyleEditButton",
                "linkButton",
                "outlinesPanelButton",
                "outlinesPanel",
                "contextMenuPopup",
                "notePopup",
                "thumbnailControl",
                "documentControl",
                "annotationContentOverlay",
                "layersPanelButton",
                "highlightToolButton",
                "highlightToolButton2",
                "highlightToolButton3",
                "highlightToolButton4",
                "underlineToolButton",
                "squigglyToolButton",
                "strikeoutToolButton",
                "ellipseToolButton",
                "lineToolButton",
                "arrowToolButton",
                "polylineToolButton",
                "polygonToolButton",
                "cloudToolButton",
                "calloutToolButton",
                "stampToolButton",
                "fileAttachmentToolButton",
                "cropToolButton",
                "freeHandToolButton",
                "freeHandToolButton2",
                "freeHandToolButton3",
                "freeHandToolButton4",
                "rectangleToolButton",
                "ribbons",
                "signaturePanelButton",
                "copyTextButton",
              ],
              css: "/vendor/pdf/lib/ui/GuestViewerStyle.css",
              isAdminUser: true,
              licenseKey: `${process.env.REACT_APP_PDFTRON_LICENSE_KEY}`,
            };

            const instance = await WebViewer(
              webViewerOptions,
              viewerRef.current
            );

            const signatureToolButtonClicked = () => {
              const toolsHeader =
                instance.UI.iframeWindow.document.querySelector(
                  ".HeaderToolsContainer"
                );
              const signatureToolButton =
                instance.UI.iframeWindow.document.querySelector(
                  "[data-element=signatureToolButton]"
                );

              const pinToolsGroupButton =
                instance.UI.iframeWindow.document.querySelector(
                  '[data-element="pinToolsGroupButton"]'
                );
              const secondaryHeader =
                instance.UI.iframeWindow.document.querySelector(
                  ".Header+.SecondaryHeader"
                );

              const pinDropCommentButton =
                instance.UI.iframeWindow.document.querySelector(
                  "#PinConversationTool"
                );

              const annotationHighlightButton =
                instance.UI.iframeWindow.document.querySelector(
                  "[data-element=annotationHighlightButton]"
                );

              if (pinToolsGroupButton) {
                pinToolsGroupButton.classList.remove("active");
              }

              if (
                annotationHighlightButton &&
                annotationHighlightButton.classList.contains("active")
              ) {
                annotationHighlightButton.classList.remove("active");
              }

              pinDropCommentButton.classList.remove("show");

              secondaryHeader.classList.remove("show");

              if (signatureToolButton.classList.contains("active")) {
                signatureToolButton.classList.remove("active");
                instance.UI.setToolMode("AnnotationEdit");
                toolsHeader.classList.remove("show");
              } else {
                signatureToolButton.classList.add("active");
                instance.UI.setToolMode("AnnotationCreateSignature");
                toolsHeader.classList.add("show");
              }
            };

            const pinToolsGroupButtonClicked = () => {
              const pinToolsGroupButton =
                instance.UI.iframeWindow.document.querySelector(
                  '[data-element="pinToolsGroupButton"]'
                );
              const secondaryHeader =
                instance.UI.iframeWindow.document.querySelector(
                  ".Header+.SecondaryHeader"
                );

              const toolsHeader =
                instance.UI.iframeWindow.document.querySelector(
                  ".HeaderToolsContainer"
                );
              const signatureToolButton =
                instance.UI.iframeWindow.document.querySelector(
                  "[data-element=signatureToolButton]"
                );

              const pinDropCommentButton =
                instance.UI.iframeWindow.document.querySelector(
                  "#PinConversationTool"
                );

              const annotationHighlightButton =
                instance.UI.iframeWindow.document.querySelector(
                  "[data-element=annotationHighlightButton]"
                );

              if (
                annotationHighlightButton &&
                annotationHighlightButton.classList.contains("active")
              ) {
                annotationHighlightButton.classList.remove("active");
              }

              if (signatureToolButton) {
                signatureToolButton.classList.remove("active");
              }
              toolsHeader.classList.remove("show");

              if (
                pinToolsGroupButton &&
                pinToolsGroupButton.classList.contains("active")
              ) {
                pinToolsGroupButton.classList.remove("active");
                instance.UI.setToolMode("AnnotationEdit");

                pinDropCommentButton.classList.remove("show");

                secondaryHeader.classList.remove("show");
              } else {
                const tools = secondaryHeader.children;
                for (let i = 0; i < tools.length; i++) {
                  tools[i].classList.remove("active");
                }
                if (pinToolsGroupButton) {
                  pinToolsGroupButton.classList.add("active");
                }
                instance.UI.setToolMode("PinConversationTool");

                pinDropCommentButton.classList.add("show");
                pinDropCommentButton.classList.add("active");

                secondaryHeader.classList.add("show");
              }
            };

            const annotationHighlightButtonClicked = () => {
              const pinToolsGroupButton =
                instance.UI.iframeWindow.document.querySelector(
                  '[data-element="pinToolsGroupButton"]'
                );
              const secondaryHeader =
                instance.UI.iframeWindow.document.querySelector(
                  ".Header+.SecondaryHeader"
                );

              const toolsHeader =
                instance.UI.iframeWindow.document.querySelector(
                  ".HeaderToolsContainer"
                );
              const signatureToolButton =
                instance.UI.iframeWindow.document.querySelector(
                  "[data-element=signatureToolButton]"
                );

              const pinDropCommentButton =
                instance.UI.iframeWindow.document.querySelector(
                  "#PinConversationTool"
                );

              if (pinToolsGroupButton) {
                pinToolsGroupButton.classList.remove("active");
              }
              signatureToolButton.classList.remove("active");

              signatureToolButton.classList.remove("show");

              pinDropCommentButton.classList.remove("show");

              secondaryHeader.classList.remove("show");

              toolsHeader.classList.remove("show");

              const annotationHighlightButton =
                instance.UI.iframeWindow.document.querySelector(
                  "[data-element=annotationHighlightButton]"
                );

              if (annotationHighlightButton.classList.contains("active")) {
                annotationHighlightButton.classList.remove("active");
              } else {
                instance.UI.setToolMode("AnnotationEdit");
                annotationHighlightButton.classList.add("active");
              }

              instance.UI.setToolMode("AnnotationEdit");
            };

            const annotationHighlightButton = {
              type: "actionButton",
              dataElement: "annotationHighlightButton",
              img: "/assets/svg/annotation-highlight.svg",
              onClick: annotationHighlightButtonClicked,
              title: "Highlight",
            };

            const signatureToolButton = {
              type: "actionButton",
              dataElement: "signatureToolButton",
              img: "/assets/svg/default-sign.svg",
              onClick: signatureToolButtonClicked,
              title: "Signatures",
            };

            const pinToolsGroupButton = {
              type: "actionButton",
              dataElement: "pinToolsGroupButton",
              img: "/assets/svg/default-pin.svg",
              onClick: pinToolsGroupButtonClicked,
              title: "Pin a Comment",
            };

            const setSecondaryHeaderActiveTool = (toolID) => {
              const secondaryHeader =
                instance.UI.iframeWindow.document.querySelector(
                  ".Header+.SecondaryHeader"
                );

              const tools = secondaryHeader.children;
              for (let i = 0; i < tools.length; i++) {
                tools[i].classList.remove("active");
              }
              instance.UI.setToolMode(toolID);

              const toolButton =
                instance.UI.iframeWindow.document.querySelector(`#${toolID}`);

              toolButton.classList.add("active");
            };

            const UIEvents = instance.UI.Events;

            instance.UI.addEventListener(UIEvents.LOAD_ERROR, () => {
              props.setError(true);
            });

            instance.UI.updateElement("viewControlsButton", {
              img: "/assets/svg/default-viewcontrols.svg",
            });

            instance.UI.updateElement("leftPanelButton", {
              img: "/assets/svg/default-leftsidepanel.svg",
            });

            instance.UI.updateElement("zoomOutButton", {
              img: "/assets/svg/default-minus.svg",
            });

            instance.UI.updateElement("panToolButton", {
              img: "/assets/svg/default-pan.svg",
            });

            instance.UI.updateElement("zoomInButton", {
              img: "/assets/svg/default-plus.svg",
            });

            instance.UI.updateElement("zoomOverlay", {
              img: "/assets/svg/chevron.svg",
            });

            instance.UI.updateElement("searchButton", {
              img: "/assets/svg/default-magnifying-glass.svg",
            });

            instance.UI.disableTools([
              "TextSelectTool",
              "AnnotationComment",
              "AnnotationCreateTextSquiggly",
              "AnnotationCreateFileAttachment",
              "AnnotationCreateAreaMeasurement",
              "AnnotationCreateArrow",
              "AnnotationCreateCallout",
              "AnnotationCreateCountMeasurement",
              "CropPage",
              "AnnotationCreateDistanceMeasurement",
              "AnnotationCreateEllipse",
              "AnnotationCreateEllipseMeasurement",
              "AnnotationEraserTool",
              "AnnotationCreateFreeHand",
              "AnnotationCreateFreeHand2",
              "AnnotationCreateFreeHand3",
              "AnnotationCreateFreeHand4",
              "AnnotationCreateFreeText",
              "AnnotationCreateLine",
              "AnnotationCreatePerimeterMeasurement",
              "AnnotationCreatePolygon",
              "AnnotationCreatePolygonCloud",
              "AnnotationCreatePolyline",
              "AnnotationCreateRectangle",
              "AnnotationCreateRectangularAreaMeasurement",
              "AnnotationCreateRedaction",
              "AnnotationCreateRubberStamp",
              "AnnotationCreateStamp",
              "AnnotationCreateSticky",
              "AnnotationCreateTextStrikeout",
              "TextSelect",
              "AnnotationCreateTextUnderline",
              "AnnotationCreateTextHighlight2",
              "AnnotationCreateTextHighlight3",
              "AnnotationCreateTextHighlight4",
              "AnnotationCreateTextHighlight",
            ]);

            instance.UI.loadDocument(
              `${loadDocumentUrl()}/share_links/view/${hashUrl}`,
              {
                onError: () => {
                  console.log("error");
                  props.setError(true);
                },
              }
            );

            const hideSecondaryHeader = () => {
              const pinToolsGroupButton =
                instance.UI.iframeWindow.document.querySelector(
                  '[data-element="pinToolsGroupButton"]'
                );
              const secondaryHeader =
                instance.UI.iframeWindow.document.querySelector(
                  ".Header+.SecondaryHeader"
                );
              const toolsHeader =
                instance.UI.iframeWindow.document.querySelector(
                  ".HeaderToolsContainer"
                );
              const signatureToolButton =
                instance.UI.iframeWindow.document.querySelector(
                  "[data-element=signatureToolButton]"
                );

              const pinDropCommentButton =
                instance.UI.iframeWindow.document.querySelector(
                  "#PinConversationTool"
                );

              const annotationHighlightButton =
                instance.UI.iframeWindow.document.querySelector(
                  "[data-element=annotationHighlightButton]"
                );

              if (annotationHighlightButton) {
                annotationHighlightButton.classList.remove("active");
              }

              if (pinToolsGroupButton) {
                pinToolsGroupButton.classList.remove("active");
              }

              pinDropCommentButton.classList.remove("show");

              if (signatureToolButton) {
                signatureToolButton.classList.remove("active");
              }

              toolsHeader.classList.remove("show");

              secondaryHeader.classList.remove("show");
            };

            const conversationStampImage =
              "data:image/svg+xml;base64,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";

            let conversationStampTool = stampTool.createStampTool(
              instance,
              conversationStampImage,
              "comment",
              props.onCloseConversationPanel,
              hideSecondaryHeader
            );

            instance.UI.registerTool({
              toolName: "PinConversationTool",
              toolObject: conversationStampTool,
              buttonImage: "/assets/svg/comment.svg",
              buttonName: "pinConversation",
              buttonGroup: "pinTools",
              tooltip: "Pin a Comment",
            });

            instance.UI.setHeaderItems(function (header) {
              const items = header.getItems();
              items.splice(
                8,
                0,
                pinToolsGroupButton,
                signatureToolButton,
                annotationHighlightButton
              );
              header.update(items);
            });

            instance.UI.setToolbarGroup("toolbarGroup-Insert");

            const secondaryHeader = document.createElement("div");

            secondaryHeader.classList.add("SecondaryHeader");

            const header = instance.UI.iframeWindow.document.querySelector(
              '[data-element="header"]'
            );

            const pinComment = document.createElement("div");
            pinComment.setAttribute("id", "PinConversationTool");
            pinComment.onclick = () =>
              setSecondaryHeaderActiveTool("PinConversationTool");
            pinComment.classList.add("tool");

            const labelComment = document.createElement("span");
            labelComment.innerText = "Pin Drop Comment";

            const imgComment = document.createElement("img");
            imgComment.src = "/assets/svg/default-comments.svg";

            pinComment.appendChild(imgComment);
            pinComment.appendChild(labelComment);

            secondaryHeader.appendChild(pinComment);

            header.after(secondaryHeader);

            // Grab the text from the highlight
            instance.Core.documentViewer.addEventListener(
              "textSelected",
              (quads, text, pageIndex) => {
                instance.UI.textPopup.update([
                  {
                    type: "actionButton",
                    img: "/assets/svg/toolbar-comment.svg",
                    onClick: () => pickComment(instance, quads, pageIndex),
                  },
                  {
                    type: "actionButton",
                    img: "/assets/svg/toolbar-strikeout.svg",
                    onClick: () => pickStrikeout(instance, quads, pageIndex),
                  },
                ]);
              }
            );

            instance.Core.documentViewer.addEventListener(
              "documentLoaded",
              () => {
                instance.UI.iframeWindow.document
                  .querySelector('[data-element="panToolButton"]')
                  .addEventListener("click", hideSecondaryHeader);

                let annotationManager = instance.Core.annotationManager;
                annotationManager.setCurrentUser("Papercurve User");

                instance.UI.setToolMode("AnnotationEdit");

                // Load user signatures
                const signatureTool = instance.Core.documentViewer.getTool(
                  "AnnotationCreateSignature"
                );

                const signatureData = [];

                props.userSignatures.forEach((signature) => {
                  if (signature.free_hand) {
                    const data = [JSON.parse(signature.signature_data)];

                    signatureData.push(data);
                  } else {
                    signatureData.push(JSON.parse(signature.signature_data));
                  }
                });

                signatureTool.importSignatures(signatureData).then(async () => {
                  let allSignatures = await instance.Core.documentViewer
                    .getTool("AnnotationCreateSignature")
                    .exportSignatures();

                  instance.Core.documentViewer
                    .getTool("AnnotationCreateSignature")
                    .addEventListener("signatureSaved", async (annotations) => {
                      if (annotations.length !== 0) {
                        const signatures = await instance.Core.documentViewer
                          .getTool("AnnotationCreateSignature")
                          .exportSignatures();

                        const freeHand =
                          typeof signatures[signatures.length - 1] === "object";
                        const signatureData = freeHand
                          ? JSON.stringify(signatures[signatures.length - 1][0])
                          : JSON.stringify(signatures[signatures.length - 1]);
                        httpClient
                          .post(
                            `/create_guest_user_signatures/${props.hashUrl}.json`,
                            {
                              user_id: props.guestUserId,
                              annotation_id: annotations[0].Id,
                              signature_data: signatureData,
                              free_hand: freeHand,
                              hash_url: props.hashUrl,
                            }
                          )
                          .then(async (response) => {
                            allSignatures = await instance.Core.documentViewer
                              .getTool("AnnotationCreateSignature")
                              .exportSignatures();
                            let updatedUserSignatures = [
                              ...props.userSignatures,
                              response.data,
                            ];
                            props.setUserSignatures(updatedUserSignatures);
                          });
                      }
                    })
                    .addEventListener(
                      "signatureDeleted",
                      async (deletedSignature, index) => {
                        const signature = allSignatures[index];
                        const freeHand = typeof signature === "object";
                        const signatureData = freeHand
                          ? JSON.stringify(signature[0])
                          : JSON.stringify(signature);

                        const signatureAnnotation = props.userSignatures.find(
                          (signature) =>
                            signature.signature_data === signatureData
                        );

                        httpClient
                          .delete(
                            `/delete_guest_user_signatures/${signatureAnnotation.id}/${props.hashUrl}.json`
                          )
                          .then((res) => {
                            props.setUserSignatures(res.data);
                          });
                      }
                    );

                  instance.Core.documentViewer
                    .getTool("AnnotationCreateSignature")
                    .addEventListener("locationSelected", () => {
                      const toolsHeader =
                        instance.UI.iframeWindow.document.querySelector(
                          ".HeaderToolsContainer"
                        );
                      const signatureToolButton =
                        instance.UI.iframeWindow.document.querySelector(
                          "[data-element=signatureToolButton]"
                        );

                      signatureToolButton.classList.add("active");
                      instance.UI.setToolMode("AnnotationCreateSignature");
                      toolsHeader.classList.add("show");
                    });
                });

                // Render document signatures

                props.signatures.forEach((signature) => {
                  annotationManager
                    .importAnnotationCommand(signature.annotation_xfdf)
                    .then((annotationList) => {
                      annotationList.forEach((annot) => {
                        const currentAnnot = props.signatures.find(
                          (sig) => sig.annotation_id === annot.Id
                        );

                        if (
                          currentAnnot &&
                          currentAnnot.user.id !== props.guestUserId
                        ) {
                          annot.ReadOnly = true;
                        } else {
                          annot.NoMove = false;
                        }
                      });
                    });
                });

                // Render Document Dynamic fields
                renderDocumentDynamicFields(
                  props.documentDynamicFields,
                  instance
                );

                // Render conversations
                addStampImageToPinComments(props.conversations).find(
                  (conversation) => {
                    if (conversation.xfdf_highlight_id) {
                      annotationManager
                        .importAnnotationCommand(
                          conversation.xfdf_highlight_string
                        )
                        .then((annotationList) => {
                          annotationList.forEach((annot) => {
                            annotationManager.redrawAnnotation(annot);
                          });
                        });
                    }
                  }
                );
              }
            );

            instance.Core.annotationManager.addEventListener(
              "annotationSelected",
              (annotationList, action) => {
                if (
                  action === "selected" &&
                  annotationList[0] &&
                  !isImportedAnnotation(annotationList[0])
                ) {
                  if (annotationList[0].Subject === "Signature") {
                    const existingSignature = props.signatures.find(
                      (signature) =>
                        signature.annotation_id === annotationList[0].Id
                    );

                    let selectedSignature;
                    if (existingSignature) {
                      selectedSignature = existingSignature;
                    } else {
                      selectedSignature = JSON.parse(
                        localStorage.getItem("addedSignature")
                      );
                    }

                    if (props.guestUserId === selectedSignature.user.id) {
                      instance.UI.enableElements([
                        "annotationPopup",
                        "annotationDeleteButton",
                      ]);
                    } else {
                      instance.UI.enableElements(["annotationPopup"]);
                    }
                    instance.UI.disableElements(["annotationStyleEditButton"]);
                  } else {
                    const pageIndex = annotationList[0].PageNumber - 1;
                    const annotationId = annotationList[0].Id;

                    // Trigger comment or reference panel in parent DocumentViewer.
                    onAnnotationSelect(pageIndex, annotationId);
                  }
                } else if (action === "deselected") {
                  instance.UI.disableElement("annotationPopup");
                }
              }
            );

            // This gets triggered when we pick comment and/or reference from the highlight TextPopup
            instance.Core.annotationManager.addEventListener(
              "annotationChanged",
              (annotations, type, info) => {
                // info.imported is true by default for annotations from pdf and annotations added by importAnnotationCommand
                if (info.imported) {
                  return;
                }
                instance.Core.annotationManager
                  .exportAnnotationCommand()
                  .then((xfdf) => {
                    annotations.forEach((annotation) => {
                      if (type === "add") {
                        if (
                          annotation.getCustomData("highlight-type") ===
                          "comment"
                        ) {
                          instance.UI.setToolMode("AnnotationEdit");
                          props.setConversationSelected(null);
                          props.setCurrentPageIndex(annotation.PageNumber);
                          props.setConversationSelected(annotation.Id);
                          props.setCurrentXFDFHighlightString(xfdf);
                        } else if (annotation.Subject === "Signature") {
                          httpClient
                            .post(
                              `/create_guest_document_signature/${props.hashUrl}.json`,
                              {
                                document_id: props.documentId,
                                user_id: props.guestUserId,
                                annotation_id: annotation.Id,
                                annotation_xfdf: xfdf,
                              }
                            )
                            .then((res) => {
                              let updatedDocumentSignatures = [
                                ...props.signatures,
                              ];
                              updatedDocumentSignatures.push(res.data);
                              props.setSignatures(updatedDocumentSignatures);
                              localStorage.setItem(
                                "addedSignature",
                                JSON.stringify(res.data)
                              );
                            });
                          signatureToolButtonClicked();
                        } else if (annotation.Subject === "Strikeout") {
                          instance.UI.setToolMode("AnnotationEdit");
                          const commentData = {
                            hash_url: props.hashUrl,
                            conversation: {
                              document_id: props.documentId,
                              page_number: annotation.PageNumber,
                              xfdf_highlight_id: annotation.Id,
                              xfdf_highlight_string: xfdf,
                            },
                            comment: {
                              body: null,
                            },
                          };

                          httpClient
                            .post("/comments/guest.json", commentData)
                            .then((response) => {
                              props.reloadConversations();
                            });
                        }
                      } else if (type === "delete") {
                        if (annotation.Subject === "Signature") {
                          const existingSignature = props.signatures.find(
                            (signature) =>
                              signature.annotation_id === annotation.Id
                          );

                          let signature;
                          if (existingSignature) {
                            signature = existingSignature;
                          } else {
                            signature = JSON.parse(
                              localStorage.getItem("addedSignature")
                            );
                          }
                          httpClient
                            .delete(
                              `/guest_document_signature/${signature.id}/${hashUrl}.json`
                            )
                            .then(() => {});
                        }
                      } else if (type === "modify") {
                        if (annotation.Subject === "Signature") {
                          const existingSignature = props.signatures.find(
                            (signature) =>
                              signature.annotation_id === annotation.Id
                          );

                          let signature;
                          if (existingSignature) {
                            signature = existingSignature;
                          } else {
                            signature = JSON.parse(
                              localStorage.getItem("addedSignature")
                            );
                          }
                          httpClient.put(
                            `/update_guest_document_signature/${signature.id}/${hashUrl}.json`,
                            {
                              annotation_xfdf: xfdf,
                            }
                          );
                        } else if (annotation.Subject === "Strikeout") {
                          httpClient
                            .put(`/conversations/${annotation.Id}/guest.json`, {
                              hash_url: hashUrl,
                              conversation: {
                                xfdf_highlight_string: xfdf,
                              },
                            })
                            .catch((error) => {
                              console.error(error);
                            });
                        }
                      }
                    });
                  });
              }
            );

            const downloadButtonDesktop = {
              type: "customElement",
              render: () => (
                <button
                  className="download-button__desktop"
                  onClick={() => downloadDoc(props.session)}
                >
                  Download
                </button>
              ),
              hidden: ["mobile"],
            };

            const downloadButtonMobile = {
              type: "customElement",
              render: () => (
                <div
                  className="download-button__mobile"
                  onClick={() => downloadDoc(props.session)}
                >
                  <img src={DownloadSVG} />
                </div>
              ),
              hidden: ["desktop", "tablet"],
            };

            instance.UI.setHeaderItems((header) => {
              const items = header.getItems();
              items.splice(4, 1);
              header.update(items);
              header.get("searchButton").insertBefore(downloadButtonDesktop);
              header.get("searchButton").insertBefore(downloadButtonMobile);
            });
          } catch (err) {
            console.log("error", err);
            props.setError(true);
          }
        };
        loadDocument();
      });
  }, []);

  const pickComment = (instance, quads, pageIndex) => {
    props.setCurrentPageIndex(pageIndex);
    props.setConversationSelected(null);

    const selectedTextQuads = quads;

    const selectedText = instance.Core.documentViewer.getSelectedText();

    const highlight = new instance.Core.Annotations.TextHighlightAnnotation();
    highlight.PageNumber = pageIndex;
    highlight.StrokeColor = new instance.Core.Annotations.Color(255, 204, 153);
    highlight.FillColor = new instance.Core.Annotations.Color(255, 204, 153);
    highlight.Quads = selectedTextQuads;
    highlight.Opacity = 0.5;
    highlight.BlendMode = "normal";

    // Custom xfdf data for the highlight
    highlight.setCustomData("highlight-type", "comment");

    const annotationManager = instance.Core.annotationManager;
    highlight.setContents(selectedText);
    highlight.Author = annotationManager.getCurrentUser();

    annotationManager.addAnnotation(highlight);
    annotationManager.drawAnnotations(highlight.PageNumber);
  };

  const pickStrikeout = (instance, quads, pageIndex) => {
    const selectedTextQuads = quads;

    const highlight = new instance.Core.Annotations.TextStrikeoutAnnotation();
    highlight.PageNumber = pageIndex;
    highlight.Quads = selectedTextQuads;
    highlight.BlendMode = "normal";

    // Custom xfdf data for the highlight
    highlight.setCustomData("highlight-type", "strikeout");

    const annotationManager = instance.Core.annotationManager;
    highlight.Author = annotationManager.getCurrentUser();

    annotationManager.addAnnotation(highlight);
    annotationManager.drawAnnotations(highlight.PageNumber);
  };

  const onAnnotationSelect = (pageIndex, xfdfHighlightId) => {
    props.setConversationSelected(xfdfHighlightId);
  };

  const renderDocumentDynamicFields = (
    updatedDocumentDynamicFields,
    instance
  ) => {
    let options = { structured: {} };

    updatedDocumentDynamicFields.map((field) => {
      // Rendering fields that have corresponding saved SC field values in the DB
      if (field.field_value && field.field_value !== "null") {
        if (field.structured_content) {
          if (field.has_attached_structured_content_image) {
            const categoryLookup = field.field_name.split(".")[1];
            const selectedRow = field.field_name.split(".")[2];

            if (options.structured.hasOwnProperty(categoryLookup)) {
              if (
                options.structured[categoryLookup].hasOwnProperty(selectedRow)
              ) {
                options.structured[categoryLookup][selectedRow] = {
                  image_url: `${loadDocumentUrl()}/document_dynamic_field/image/${
                    field.id
                  }`,
                  width: field.image_width ? parseInt(field.image_width) : 64,
                  height: field.image_height
                    ? parseInt(field.image_height)
                    : 64,
                };
              } else {
                options.structured[categoryLookup][selectedRow] = {};
                options.structured[categoryLookup][selectedRow] = {
                  image_url: `${loadDocumentUrl()}/document_dynamic_field/image/${
                    field.id
                  }`,
                  width: field.image_width ? parseInt(field.image_width) : 64,
                  height: field.image_height
                    ? parseInt(field.image_height)
                    : 64,
                };
              }
            } else {
              options.structured[categoryLookup] = {};
              options.structured[categoryLookup][selectedRow] = {};
              options.structured[categoryLookup][selectedRow] = {
                image_url: `${loadDocumentUrl()}/document_dynamic_field/image/${
                  field.id
                }`,
                width: field.image_width ? parseInt(field.image_width) : 64,
                height: field.image_height ? parseInt(field.image_height) : 64,
              };
            }
          } else {
            // Rendering structured content fields that have multiple grouped properties
            if (field.field_name.split(".").length === 4) {
              const categoryLookup = field.field_name.split(".")[1];
              const selectedRow = field.field_name.split(".")[2];
              const name = field.field_name.split(".")[3];
              if (options.structured.hasOwnProperty(categoryLookup)) {
                if (
                  options.structured[categoryLookup].hasOwnProperty(selectedRow)
                ) {
                  options.structured[categoryLookup][selectedRow][name] =
                    field.field_value;
                } else {
                  options.structured[categoryLookup][selectedRow] = {};
                  options.structured[categoryLookup][selectedRow][name] =
                    field.field_value;
                }
              } else {
                options.structured[categoryLookup] = {};
                options.structured[categoryLookup][selectedRow] = {};
                options.structured[categoryLookup][selectedRow][name] =
                  field.field_value;
              }
              // Rendering structured content fields that DO NOT have multiple grouped properties
            } else if (field.field_name.split(".").length === 3) {
              const categoryLookup = field.field_name.split(".")[1];
              const selectedRow = field.field_name.split(".")[2];
              if (options.structured.hasOwnProperty(categoryLookup)) {
                if (
                  options.structured[categoryLookup].hasOwnProperty(selectedRow)
                ) {
                  options.structured[categoryLookup][selectedRow] =
                    field.field_value;
                } else {
                  options.structured[categoryLookup][selectedRow] = {};
                  options.structured[categoryLookup][selectedRow] =
                    field.field_value;
                }
              } else {
                options.structured[categoryLookup] = {};
                options.structured[categoryLookup][selectedRow] = {};
                options.structured[categoryLookup][selectedRow] =
                  field.field_value;
              }
            } else {
              const categoryLookup = field.field_name;
              options[categoryLookup] = {};
              options[categoryLookup] = field.field_value;
            }
          }
        } else {
          if (field.field_name.split(".").length === 1) {
            // Handling the rendering of non-structured template fields
            options[field.field_name] = field.field_value;
          } else {
            // Handling the rendering of structured_product_claims
            const categoryLookup = field.field_name.split(".")[1];
            const selectedRow = field.field_name.split(".")[2];

            if (options.structured.hasOwnProperty(categoryLookup)) {
              if (
                options.structured[categoryLookup].hasOwnProperty(selectedRow)
              ) {
                options.structured[categoryLookup][selectedRow] =
                  field.field_value;
              } else {
                options.structured[categoryLookup][selectedRow] = {};
                options.structured[categoryLookup][selectedRow] =
                  field.field_value;
              }
            } else {
              options.structured[categoryLookup] = {};
              options.structured[categoryLookup][selectedRow] = {};
              options.structured[categoryLookup][selectedRow] =
                field.field_value;
            }
          }
        }
      } else {
        // Rendering non-structured image fields
        if (field.field_name.split(".")[0] === "image") {
          const imageIdentifier = field.field_name.split(".")[1];
          if (field.has_attached_image) {
            if (options.hasOwnProperty("image")) {
              if (options.image.hasOwnProperty(imageIdentifier)) {
                options.image[imageIdentifier] = {
                  image_url: `${loadDocumentUrl()}/document_dynamic_field/image/${
                    field.id
                  }`,
                  width: field.image_width ? parseInt(field.image_width) : 64,
                  height: field.image_height
                    ? parseInt(field.image_height)
                    : 64,
                };
              } else {
                options.image[imageIdentifier] = {};
                options.image[imageIdentifier] = {
                  image_url: `${loadDocumentUrl()}/document_dynamic_field/image/${
                    field.id
                  }`,
                  width: field.image_width ? parseInt(field.image_width) : 64,
                  height: field.image_height
                    ? parseInt(field.image_height)
                    : 64,
                };
              }
            } else {
              options["image"] = {};
              options["image"][imageIdentifier] = {};
              options["image"][imageIdentifier] = {
                image_url: `${loadDocumentUrl()}/document_dynamic_field/image/${
                  field.id
                }`,
                width: field.image_width ? parseInt(field.image_width) : 64,
                height: field.image_height ? parseInt(field.image_height) : 64,
              };
            }
          } else {
            if (options.hasOwnProperty("image")) {
              options["image"][imageIdentifier] = `{{${field.field_name}}}`;
            } else {
              options["image"] = {};
              options["image"][imageIdentifier] = `{{${field.field_name}}}`;
            }
          }
        }

        // Rendering fields that DO NOT have corresponding saved SC field values in the DB
        // Rendering structured content fields that have multiple grouped properties
        if (field.field_name.split(".").length === 4) {
          const categoryLookup = field.field_name.split(".")[1];
          const selectedRow = field.field_name.split(".")[2];
          const name = field.field_name.split(".")[3];
          if (options.structured.hasOwnProperty(categoryLookup)) {
            if (
              options.structured[categoryLookup].hasOwnProperty(selectedRow)
            ) {
              options.structured[categoryLookup][selectedRow][
                name
              ] = `{{${field.field_name}}}`;
            } else {
              options.structured[categoryLookup][selectedRow] = {};
              options.structured[categoryLookup][selectedRow][
                name
              ] = `{{${field.field_name}}}`;
            }
          } else {
            options.structured[categoryLookup] = {};
            options.structured[categoryLookup][selectedRow] = {};
            options.structured[categoryLookup][selectedRow][
              name
            ] = `{{${field.field_name}}}`;
          }
          // Rendering structured content fields that DO NOT have multiple grouped properties
        } else if (field.field_name.split(".").length === 3) {
          const categoryLookup = field.field_name.split(".")[1];
          const selectedRow = field.field_name.split(".")[2];
          if (options.structured.hasOwnProperty(categoryLookup)) {
            if (
              options.structured[categoryLookup].hasOwnProperty(selectedRow)
            ) {
              options.structured[categoryLookup][
                selectedRow
              ] = `{{${field.field_name}}}`;
            } else {
              options.structured[categoryLookup][selectedRow] = {};
              options.structured[categoryLookup][
                selectedRow
              ] = `{{${field.field_name}}}`;
            }
          } else {
            options.structured[categoryLookup] = {};
            options.structured[categoryLookup][selectedRow] = {};
            options.structured[categoryLookup][
              selectedRow
            ] = `{{${field.field_name}}}`;
          }
        } else {
          const categoryLookup = field.field_name;
          options[categoryLookup] = {};
          options[categoryLookup] = `{{${field.field_name}}}`;
        }
      }
    });

    instance.Core.documentViewer.getDocument().applyTemplateValues(options);
  };

  return (
    <div
      className={
        Object.keys(props.approval).length > 0 &&
        props.approval.status === "pending"
          ? styles.containerApprovalsPresent
          : styles.container
      }
    >
      <div className={styles.webViewerContainer} ref={viewerRef}></div>
    </div>
  );
};

const useStateRef = (initialValue) => {
  const [value, setValue] = useState(initialValue);

  const ref = useRef(value);

  useEffect(() => {
    ref.current = value;
  }, [value]);

  return [value, setValue, ref];
};

export default PDFTGuestViewer;
